import {
  authConnectionService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_AUTH_CONNECTIONS,
  SET_REFERENCES,
  ADD_CONNECTION,
  REPLACE_CONNECTION,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';
import {
  GET_AUTH_CONNECTIONS,
  CREATE_AUTH_CONNECTION,
  UPDATE_AUTH_CONNECTION,
  GET_REFERENCES,
  DELETE_AUTH_CONNECTION,
  GET_USER_VISIBLE_COLUMNS,
  VALIDATE_AUTH_CONNECTION,
} from './actionTypes';
import { filter, map } from 'lodash';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';

const actions = {
  async [GET_AUTH_CONNECTIONS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_AUTH_CONNECTIONS });      
    commit(SET_AUTH_CONNECTIONS, []);
    try {      
      const response = await authConnectionService.getAuthConnections(rootState.currentAccountId);
      commit(SET_AUTH_CONNECTIONS, response.data.authConnections);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_AUTH_CONNECTIONS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_AUTH_CONNECTIONS, error: e });
    }
  },
  async [CREATE_AUTH_CONNECTION]({ rootState, commit }, authConnection) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_AUTH_CONNECTION });
    try {
      const response = await authConnectionService.createAuthConnection(rootState.currentAccountId, authConnection);
      commit(ADD_CONNECTION, response.data.authConnection);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_AUTH_CONNECTION });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_AUTH_CONNECTION, error: e });
    }
  },
  async [UPDATE_AUTH_CONNECTION]({ rootState, commit }, authConnection) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_AUTH_CONNECTION });
    try {
      const response = await authConnectionService.updateAuthConnection(rootState.currentAccountId, authConnection);
      commit(REPLACE_CONNECTION, response.data.authConnection);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_AUTH_CONNECTION });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_AUTH_CONNECTION, error: e });
    }
  },
  async [GET_REFERENCES]({ rootState, commit }, authConnectionId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_REFERENCES });
    try {
      const response = await authConnectionService.getAuthConnectionReferences(rootState.currentAccountId, authConnectionId);
      commit(SET_REFERENCES, response.data);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_REFERENCES });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_REFERENCES, error: e });
    }
  },
  async [DELETE_AUTH_CONNECTION]({ rootState, commit, dispatch }, authConnectionId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_AUTH_CONNECTION });
    try {
      await authConnectionService.deleteAuthConnection(rootState.currentAccountId, authConnectionId, true);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_AUTH_CONNECTION });
      dispatch(GET_AUTH_CONNECTIONS);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_AUTH_CONNECTION, error: e });
    }
  },
  async [VALIDATE_AUTH_CONNECTION]({ rootState, commit, dispatch }, authConnectionId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: VALIDATE_AUTH_CONNECTION });
    try {
      await authConnectionService.validateAuthConnection(rootState.currentAccountId, authConnectionId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: VALIDATE_AUTH_CONNECTION });
      dispatch(GET_AUTH_CONNECTIONS);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: VALIDATE_AUTH_CONNECTION, error: e });
    }
  },
  async [GET_USER_VISIBLE_COLUMNS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_VISIBLE_COLUMNS });
    commit(SET_USER_VISIBLE_COLUMNS, []);
    try {
      const userVisibleColumns = map(filter(authConnectionService.columnSettings, (col) => !col.hide), (col) => {
        return col.name || col.displayName;
      });
      commit(SET_USER_VISIBLE_COLUMNS, userVisibleColumns);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_VISIBLE_COLUMNS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_VISIBLE_COLUMNS, error: e });
    }
  }
};

export default actions;